"use strict";
exports.__esModule = true;
var MAIN_COLOR = "#538DDA";
var SIBLING_COLOR = '#f9a65a';
function makeSeriesData(rows) {
    return {
        range: rows.map(function (row) {
            return [row[0], row[1], row[3]];
        }),
        base: rows.map(function (row) {
            return [row[0], row[2]];
        })
    };
}
function makeSeries(seriesData, color, nodeName) {
    return [{
            type: 'scatter',
            name: nodeName,
            color: color,
            marker: {
                symbol: 'square'
            },
            data: [],
            showInLegend: true
        }, {
            linkedTo: ':previous',
            name: nodeName,
            data: seriesData['base'],
            zIndex: 0,
            color: color,
            tooltip: {
                enabled: false
            },
            marker: {
                symbol: 'circle',
                enabled: false
            },
            showInLegend: false
        }, {
            name: nodeName,
            data: seriesData['range'],
            type: 'arearange',
            linkedTo: ':previous',
            lineWidth: 0,
            color: color,
            fillOpacity: 0.3,
            zIndex: 1,
            marker: {
                symbol: 'circle',
                enabled: false
            },
            showInLegend: false
        }];
}
function getChartOptions(graph, options) {
    var chartTitle = options.chartTitle, currentNode = options.currentNode, settings = options.settings, timestamp = options.timestamp;
    var nodeName = currentNode['name'];
    var seriesData = makeSeriesData(graph.mainRows);
    var series = makeSeries(seriesData, MAIN_COLOR, nodeName);
    if (graph.siblingRows.length > 0) {
        var siblingSeriesData = makeSeriesData(graph.siblingRows);
        var siblingSeries = makeSeries(siblingSeriesData, SIBLING_COLOR, graph.siblingNodeName);
        series = series.concat(siblingSeries);
    }
    return {
        chart: {
            renderTo: 'chartContainer',
            height: 500,
            width: 750,
            zoomType: 'xy'
        },
        credits: {
            text: timestamp,
            href: null
        },
        plotOptions: {
            series: {
                stickyTracking: false
            }
        },
        legend: {
            enabled: true,
            squareSymbol: true
        },
        title: {
            text: chartTitle
        },
        tooltip: {
            enabled: settings.showTooltip,
            crosshairs: true,
            borderColor: '#A9A9A9',
            shared: true,
            formatter: function () {
                var points = angular.copy(this.points);
                if (settings.decimals !== 'Default') {
                    points.forEach(function (point, index) {
                        if (index % 2 == 0) {
                            point['point']['options']['y'] = point['point']['options']['y'].toFixed(settings.decimals);
                        }
                        else {
                            point['point']['options']['low'] = point['point']['options']['low'].toFixed(settings.decimals);
                            point['point']['options']['high'] = point['point']['options']['high'].toFixed(settings.decimals);
                        }
                    });
                }
                var tooltip = "<b>" + this.points[0]['x'] + "</b> <br/>" +
                    (" <span style=\"color: " + MAIN_COLOR + "; font-weight:bold;\"> High (90%) : </span> " + points[1]['point']['options']['high'] + " <br/>") +
                    (" <span style=\"color: " + MAIN_COLOR + "; font-weight:bold;\"> Mid (50%) : </span> " + points[0]['point']['options']['y'] + " <br/>") +
                    (" <span style=\"color: " + MAIN_COLOR + "; font-weight:bold;\"> Low (10%) : </span> " + points[1]['point']['options']['low'] + " ");
                if (this.points.length > 2) {
                    tooltip = tooltip +
                        (" <br/> <span style=\"color: " + SIBLING_COLOR + "; font-weight:bold;\"> High (90%) : </span> " + points[3]['point']['options']['high'] + " <br/>") +
                        (" <span style=\"color: " + SIBLING_COLOR + "; font-weight:bold;\"> Mid (50%) : </span> " + points[2]['point']['options']['y'] + " <br/>") +
                        (" <span style=\"color: " + SIBLING_COLOR + "; font-weight:bold;\"> Low (10%) : </span> " + points[3]['point']['options']['low'] + " ");
                }
                return tooltip;
            }
        },
        xAxis: {
            title: {
                text: 'Year'
            },
            tickInterval: 1
        },
        yAxis: {
            title: {
                text: 'Revenue ($MM)'
            }
        },
        series: series
    };
}
exports.getChartOptions = getChartOptions;
//# sourceMappingURL=envelope-chart.chart.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/envelope-chart/envelope-chart.chart.js